import PropTypes from "prop-types";

const PaginationButton = ({ pageNum, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-8 h-8 rounded-sm border ${
        isActive
          ? "bg-prime-red text-zinc-100 border-prime-red"
          : "bg-transparent text-prime-red border-prime-red hover:bg-prime-red/10"
      } transition-all duration-300`}
    >
      {pageNum}
    </button>
  );
};

PaginationButton.propTypes = {
  pageNum: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

PaginationButton.defaultProps = {
  isActive: false,
};

export default PaginationButton;
